import { gql } from '@apollo/client'

export const CustomerFragment = gql`
  fragment CustomerFragment on Customer {
    id
    email
    taxId
    hasDefaultPaymentMethod
    billing {
      address {
        line1
        line2
        zipCode
        city
        country
      }
    }
  }
`
